import React from 'react';
import PropTypes from 'prop-types';

const Detail = ({ children, Style }) => <div className={Style.details}>{children}</div>;

export default Detail;

Detail.propTypes = {
  children: PropTypes.node,
  Style: PropTypes.shape({}),
};
